module.exports = __webpack_public_path__ + "img/people.1df1f3a0.png";